module.exports = __webpack_public_path__ + "img/image7.ee74665d.webp";